module.exports = __webpack_public_path__ + "assets/img/logo-tablet.153bfa9c.png";